<template>
    <div class="lesson_main" :style="{backgroundColor:getSuccessSubCourseColor()}">
        <div class="transition" v-if="showTransition" @click="closeTransition">
            <div class="content">
                <img src="@/assets/transition_back.png"/>
                <div class="text">
                    <span>故事音频和生词全部了解了，祝贺！<br/>接下来我们用练习的方式，<br/>来梳理下文章结构吧～</span>
                </div>
            </div>

            <div class="wrapper">
                <div class="wrapper-content left">
                    <div class="wrapper_back" @click="backCourseMain">
                        <span>返回课程</span>
                    </div>
                </div>
                <div class="wrapper-content left1">
                    <div class="wrapper_back" @click="nextClick">
                        <span>继续学习</span>
                    </div>
                </div>
            </div>
        </div>
        <HeaderNav v-if="!isWeixinBrowser()" :navtitle="lessonTitle" :beforecolor="'#fff'" :backcolor="getSuccessSubCourseColor()"
                   @returnBack="goToBack"></HeaderNav>
        <div class="lesson_audio">
            <div class="info">
                <div class="title">故事音频</div>
                <div class="mp3_progress">
                    <div class="now_progress" v-bind:style="{width: progress+ '%'}"></div>
                </div>
                <div class="time">
                    <div class="time_start">{{realFormatSecond(currentTime)}}</div>
                    <div class="time_end">{{objPartInfo.audioDurationDisplayString}}</div>
                    <div class="clear"></div>
                </div>
            </div>
            <div class="play" @click="changeStart">
                <audio v-bind:src="$qiNiuDomainBase + objPartInfo.audio" id="musicMp3" controls=""></audio>
                <img v-if="!isPlay" src="@/assets/player_play.png" height="40" width="40"/>
                <img v-else src="@/assets/player_pause.png" height="40" width="40"/>
            </div>
            <div class="clear"></div>
        </div>
        <div class="words_list" v-if="objPartInfo.wordArray != null && objPartInfo.wordArray.length > 0">
            <div class="title">词汇清单</div>
            <div class="list">
                <div class="word_card_item" v-for="(wordCard,index) in objPartInfo.wordArray" :key="index"
                     @click="wordClick(wordCard.youdaoUrl, wordCard.word)">
                    <div class="word">{{wordCard.word}}</div>
                    <div class="example">{{wordCard.chineseInterpretation}}</div>
                    <div class="card_in">详细释义 ></div>
                </div>
                <div class="clear"></div>
            </div>
            <div class="bottom"></div>
        </div>
        <div class="start_learn" @click="startLearnClick">
            <div class="btn">继续</div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                lessonId: 0,
                lessonTitle: "音频 & 词汇",
                objPartInfo: {},
                progress: 0,
                isPlay: false,
                currentTime: 0,
                mTimer: null,
                showTransition: false,
            }
        },
        methods: {
            goToBack() {
                this.goBack(this.$router);
            },
            wordClick: function (youdaoUrl, word) {
                if (!this.isEmpty(youdaoUrl)) {
                    this.$router.push({name: 'pageView', query: {url: "https://m.youdao.com/dict?le=eng&q=" + word}});
                }
            },
            startLearnClick: function () {
                this.showTransition = true;
            },
            closeTransition() {
                this.showTransition = false;
            },
            backCourseMain() {
                this.$router.go(-2);
            },
            nextClick() {
                this.$router.go(-2);
                setTimeout(() => {
                    this.$router.push({
                        name: "SQuestion",
                        query: {
                            lessonId: this.lessonId,
                        }
                    });
                }, 200);
            },
            changeStart: function () {
                let that = this;
                that.isPlay = !that.isPlay
                const musicMp3 = document.getElementById('musicMp3')
                if (that.isPlay) {
                    if (that.mTimer == null) {
                        that.changeProgress();
                    }
                    musicMp3.play()
                } else {
                    musicMp3.pause()
                }
            },
            changeProgress: function () {
                let that = this;
                const musicMp3 = document.getElementById('musicMp3')

                that.mTimer = setInterval(() => {
                    const numbers = musicMp3.currentTime / musicMp3.duration
                    let perNumber = (numbers * 100).toFixed(2)
                    if (perNumber >= 100) {
                        that.isPlay = false
                        that.progress = 0
                        that.currentTime = 0
                        clearInterval(that.mTimer)
                        that.mTimer = null;
                    } else {
                        that.progress = perNumber
                        that.currentTime = musicMp3.currentTime;
                    }
                }, 50)
            },
            callChangeProgress: function () {
                let that = this;
                document.getElementById('musicMp3').pause()
                that.changeProgress()
            }
        },
        mounted: function () {
            this.callChangeProgress();
            window.SWordListScrollTop = 0;
        },
        beforeRouteLeave(to, from, next) {
            window.SWordListScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            next()
        },
        activated() {
            window.scrollTo(0, window.SWordListScrollTop);
        },
        beforeCreate() {
            let vlessonId = parseInt(this.$route.query.lessonId);
            let url = "success/getLessonAudioAndWords/" + vlessonId;
            let that = this;

            this.$axios.get(url).then((response) => {
                that.objPartInfo = response.data;
                that.lessonId = vlessonId;
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        destoryed() {
            let that = this;

            if (that.mTimer != null) {
                clearInterval(that.mTimer)
                that.mTimer = null
            }
        }
    }
</script>

<style scoped>
    .lesson_main {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
    }

    .lesson_main .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 9999;
    }

    .lesson_main .transition .content {
        position: relative;
        background-color: transparent;
        /*background:url("../../../assets/transition_back.png");*/
        text-align: center;
        z-index: 10000;
    }

    .lesson_main .transition .content img {
        margin-top: 50px;
        margin-bottom: 50px;
        width: 100%;
        height: auto;
    }

    .lesson_main .transition .content .text {
        width: 100%;
        position: absolute;
        bottom: 0;
    }

    .lesson_main .transition .content span {
        width: 100%;
        color: white;
        font-size: 18px;
        font-weight: bold;
        line-height: 30px;
    }

    .wrapper {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .wrapper-content {
        width: 50%;
        text-align: center;
        margin-top: 60px;
    }

    .wrapper .left {
        padding-left: calc((100% - 300px)/3);
    }

    .wrapper .left1 {
        padding-left: calc((100% - 300px)/6);
    }

    .wrapper_back {
        width: 150px;
        height: 40px;
        text-align: center;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        background-color: #3b9c55;
    }

    .wrapper_back span {
        color: white;
        height: 40px;
        line-height: 40px;
        text-align: center;
    }

    .lesson_audio {
        position: relative;
        background-color: white;
        margin: 20px 20px 0px 20px;
        padding: 15px;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
    }

    .lesson_audio .info {
        margin-right: 50px;
    }

    .lesson_audio .play {
        position: absolute;
        top: 50%;
        right: 15px;
        -webkit-transform: translateY(-50%);
    }

    .lesson_audio .info .title {
        font-size: 15px;
        font-weight: bold;
        color: #333333;
    }

    .lesson_audio .info .mp3_progress {
        width: 100%;
        height: 4px;
        background-color: #f4f4f4;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .lesson_audio .info .now_progress {
        position: relative;
    @extend % transition;
        height: 4px;
        background-color: #64c846;
    }

    .lesson_audio .time {
        font-size: 12px;
        color: #999999;
    }

    .lesson_audio .time .time_start {
        float: left;
    }

    .lesson_audio .time .time_end {
        float: right;
    }

    audio {
        display: none;
    }

    .words_list .title {
        font-size: 20px;
        font-weight: bold;
        color: white;
        text-align: center;
        margin-top: 30px;
    }

    .words_list .bottom {
        height: 80px;
    }

    .words_list .list {
        margin-top: 20px;
        margin-left: 7px;
        margin-right: 8px;
    }

    .words_list .list .word_card_item {
        background-color: white;
        width: calc((100% - 30px) / 2);
        margin-left: 8px;
        margin-right: 7px;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        margin-bottom: 15px;
        float: left;
    }

    .words_list .list .word_card_item .word {
        margin-top: 15px;
        text-align: center;
        color: #333333;
        font-size: 20px;
        font-weight: bold;
    }

    .words_list .list .word_card_item .example {
        text-align: center;
        font-size: 17px;
        color: #333333;
        margin-top: 15px;
    }

    .words_list .list .word_card_item .card_in {
        text-align: center;
        font-size: 15px;
        color: #999999;
        margin-top: 5px;
        margin-bottom: 15px;
    }

    .start_learn {
        position: fixed;
        bottom: 0px;
        height: 70px;
        background-color: white;
        width: 100%;
    }

    .start_learn .btn {
        height: 50px;
        margin-top: 10px;
        text-align: center;
        background-color: #369e54;
        color: white;
        font-size: 20px;
        line-height: 50px;
        margin-left: 30px;
        margin-right: 30px;
        -webkit-border-radius: 25px;
        -moz-border-radius: 25px;
        margin-bottom: 25px;
    }
</style>
